
<div class="header"></div>
<app-modal-content>
    <h2>{{'components.isMarketingDialog.header' | translate}}</h2>
    <p>{{'components.isMarketingDialog.body' | translate}}</p>
</app-modal-content>
<app-modal-toolbar>
  <app-modal-buttons>
    <button mat-flat-button color="primary" (click)="onClose(true)">{{'components.isMarketingDialog.confirm' | translate}}</button>
    <button mat-stroked-button (click)="onClose(false)">{{'components.isMarketingDialog.decline' | translate}}</button>
  </app-modal-buttons>
</app-modal-toolbar>